import PropTypes from 'prop-types';

/**
 * The profile's tabs in the ticket's order, keyed by the URL slug each one
 * deep-links to. The bare profile URL shows the first.
 */
export const LOCATION_USER_TABS = [
  { value: 'account', label: 'Account Info' },
  { value: 'locations', label: 'Locations' },
  { value: 'notifications', label: 'Notifications' },
  { value: 'nps', label: 'NPS' },
];

export const DEFAULT_LOCATION_USER_TAB = LOCATION_USER_TABS[0].value;

export const isLocationUserTab = (slug) => LOCATION_USER_TABS.some((tab) => tab.value === slug);

/**
 * The four fields an admin can edit, in the order the card shows them. `key`
 * is the field's name on the profile and on `ILocationUserChanges`.
 */
export const EDITABLE_ACCOUNT_FIELDS = [
  { key: 'firstName', label: 'First Name', id: 'first-name', requiredMessage: 'First name is required.' },
  { key: 'lastName', label: 'Last Name', id: 'last-name', requiredMessage: 'Last name is required.' },
  { key: 'email', label: 'Email', id: 'email', requiredMessage: 'Email is required.' },
  { key: 'phoneNumber', label: 'Phone', id: 'phone', requiredMessage: 'Phone is required.' },
];

/** The rate-limit table's columns, then the membership key each limit reads. */
export const RATE_LIMIT_PROFESSIONS = [
  { key: 'rdh', label: 'RDH' },
  { key: 'da', label: 'DA' },
  { key: 'dn', label: 'DN' },
  { key: 'fd', label: 'FD' },
];

/** `ILocationUserProfile` (src/domain/Users/types/User.js), as the tabs read it. */
export const locationUserProfilePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  phoneLabel: PropTypes.string.isRequired,
  createdAtLabel: PropTypes.string.isRequired,
  lastLoginLabel: PropTypes.string.isRequired,
  timeZoneLabel: PropTypes.string.isRequired,
});
